<template>
  <div @click="handleClick" class="position-relative questioner-answer" :class="{'green-stripe': first}">
    <div class="questionare-text bold">{{ inner }}</div>
  </div>
</template>

<script>
export default {
  name: "Button",
  props: {
    inner: String,
    next: Number,
    value: [Array, String, Boolean],
    dataRef: String,
    first: Boolean
  },
  methods: {
    handleClick() {
      this.$emit("select", {next: this.next, value: this.value, dataRef: this.dataRef});
    }
  }
}
</script>

<style lang="scss" scoped>

</style>